import Activities from "../../Activities/components/Activities";

const AuditSurvey = () => <Activities startActivityType={5}/>

export default AuditSurvey;